import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./AccumulationCodeListFormConfig";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../common_nextgen/common_components/common-hooks/useLocationState";
const screenInfo = {
  ADD: ["Add Accumulation Code List", "RCAL1003"],
  EDIT: ["Accumulation Code List Detail", "RCAL1002"],
  CHANGE: ["Accumulation Code List Detail", "RCAL1002"],
};
const { ACCUMULATION_CODE_LIST, ACCUMULATION_CODE_LIST_CODES } = ROUTE_PATHS;

const AccumulationCodeForm = ({
  mode,
  selectMode,
  selectedCode,
  hideModal,
}) => {
  const location = useLocation();

  /* const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1); */

  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state ?? [],
  });

  let {
    selectedCodes = [],
    previousScreen = ACCUMULATION_CODE_LIST,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    externalScreenNumber = null,
    externalScreenTitle = null,
  } = currentState;

  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  useReceiveExternalMessages(setStateVal, setExternalMode);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();

  const lastScheduleName =
    selectedCodes[currentIndex]?.al1AccumulationCodeLst || "";
  const updatedParamsData = {
    ...currentState.paramsData,
    al1AccumulationCodeLst: lastScheduleName,
  };

  const handleBack = useCallback(() => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (selectMode) {
      hideModal();
    } else if (currentIndex < selectedCodes.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setInitialFormData({});
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, [
        ...previousState,
        /* {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex: currentIndex,
        },*/
      ]);
    }
  }, [currentIndex, selectedCodes, previousState]);

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitFormData = (data) => {
    setDataForSubmission(data);
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";

    if (isAddMode(currentMode)) {
      url = "api/al1AccumulationCodeLst";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/al1AccumulationCodeLst";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: "No Change of Information",
          life: 3000,
        });
        return;
      }
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      setInitialFormData(responseData);
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const lastestPreviousState = previousState.pop() ?? {};
        const latestCurrentState = {
          ...currentState,
          selectedCodes: [{ ...responseData }],
          currentIndex: 0,
        };
        const updatedState = [...previousState,{paramsData: {al1AccumulationCodeLst: responseData?.al1AccumulationCodeLst }}, latestCurrentState];
        setStateVal(updatedState);
        navigateToPage(ROUTE_PATHS.ACCUMULATION_CODE_LIST_EDIT, updatedState);
      }
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    if (selectMode) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      };
      keyName.chmod = "View";
      keyFunc.F7 = () =>
        navigateToPage(ACCUMULATION_CODE_LIST_CODES, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedCodes: [initialFormData],
            previousScreen: location.pathname,
            currentIndex: 0,
            externalScreenNumber,
            externalScreenTitle,
          },
        ]);
      keyName.F7 = "Accumulation Codes";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F7 = () =>
        navigateToPage(ACCUMULATION_CODE_LIST_CODES, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedCodes: [selectedCodes[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0,
            externalScreenNumber,
            externalScreenTitle,
          },
        ]);
      keyName.F7 = "Accumulation Codes";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, previousState, currentState, initialFormData]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const url = isAddMode(currentMode)
        ? `api/al1AccumulationCodeLst/initialFormData/${encodeURIComponent(
            screenInfo.ADD[1]
          )}`
        : "api/al1AccumulationCodeLst/" +
          encodeURIComponent(
            selectMode
              ? selectedCode[0]?.al1AccumulationCodeLst
              : selectedCodes[currentIndex].al1AccumulationCodeLst
          );
      const { responseData } = await axios_helper_no_header("GET", url);
      setInitialFormData(responseData);
    };

    if (
      (isAddMode(currentMode) || selectedCodes.length) &&
      !Object.keys(initialFormData).length
    )
      fetchInitialData();
  }, [mode, currentIndex, selectedCodes, initialFormData]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default AccumulationCodeForm;
